import { useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

export default function Products() {
    const [rows, setRows] = useState([]);
    const [brands, setBrands] = useState([]);
    const [brand, setBrand] = useState("all");
    const [q, setQ] = useState("");

    useEffect(() => {
        http.get("/masters/brands").then((r) => setBrands(r.data));
    }, []);

    useEffect(() => {
        const params = { limit: 500 };
        if (brand !== "all") params.brand_id = brand;
        if (q) params.q = q;
        http.get("/masters/products", { params }).then((r) => setRows(r.data));
    }, [brand, q]);

    const brandName = useMemo(() => {
        const m = new Map(brands.map((b) => [b.id, b.name]));
        return (id) => m.get(id) || "—";
    }, [brands]);

    return (
        <div className="mx-auto max-w-[1560px] space-y-4 p-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="mlabel">Master Data · Products</div>
                    <h1 className="text-[22px] font-semibold tracking-tight">SKU Catalog</h1>
                </div>
                <div className="text-[11px] text-muted-foreground">{rows.length} SKUs</div>
            </div>

            <div className="flex items-center gap-2">
                <input
                    data-testid="products-search"
                    placeholder="Search SKU or product…"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    className="w-72 rounded-sm border border-border bg-background px-3 py-1.5 text-[12px] outline-none focus:border-primary/60"
                />
                <div className="flex items-center gap-1 rounded-sm border border-border bg-card p-0.5">
                    <button
                        onClick={() => setBrand("all")}
                        data-testid="brand-filter-all"
                        className={
                            "rounded-sm px-2.5 py-1 text-[11px] font-medium transition-colors " +
                            (brand === "all"
                                ? "bg-primary text-primary-foreground"
                                : "text-muted-foreground hover:text-foreground")
                        }
                    >
                        All
                    </button>
                    {brands.map((b) => (
                        <button
                            key={b.id}
                            onClick={() => setBrand(b.id)}
                            data-testid={`brand-filter-${b.code}`}
                            className={
                                "rounded-sm px-2.5 py-1 text-[11px] font-medium transition-colors " +
                                (brand === b.id
                                    ? "bg-primary text-primary-foreground"
                                    : "text-muted-foreground hover:text-foreground")
                            }
                        >
                            {b.code}
                        </button>
                    ))}
                </div>
            </div>

            <div className="overflow-hidden rounded-sm border border-border bg-card" data-testid="products-table">
                <div className="max-h-[calc(100vh-260px)] overflow-auto">
                    <table className="w-full text-[12px]">
                        <thead className="sticky top-0 z-10 bg-muted/60 text-[10px] uppercase tracking-wider text-muted-foreground">
                            <tr>
                                <th className="px-3 py-2 text-left font-semibold">SKU</th>
                                <th className="px-3 py-2 text-left font-semibold">Name</th>
                                <th className="px-3 py-2 text-left font-semibold">Brand</th>
                                <th className="px-3 py-2 text-left font-semibold">Category</th>
                                <th className="px-3 py-2 text-left font-semibold">Sub-category</th>
                                <th className="px-3 py-2 text-right font-semibold">MRP</th>
                                <th className="px-3 py-2 text-right font-semibold">Cost</th>
                                <th className="px-3 py-2 text-right font-semibold">GST %</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r) => (
                                <tr
                                    key={r.id}
                                    data-testid={`product-row-${r.id}`}
                                    className="border-t border-border hover:bg-muted/40"
                                >
                                    <td className="mono-num px-3 py-1.5 font-medium">{r.sku}</td>
                                    <td className="px-3 py-1.5">{r.name}</td>
                                    <td className="px-3 py-1.5 text-muted-foreground">{brandName(r.brand_id)}</td>
                                    <td className="px-3 py-1.5">{r.category}</td>
                                    <td className="px-3 py-1.5 text-muted-foreground">{r.subcategory}</td>
                                    <td className="mono-num px-3 py-1.5 text-right">₹{r.mrp}</td>
                                    <td className="mono-num px-3 py-1.5 text-right text-muted-foreground">₹{r.cost}</td>
                                    <td className="mono-num px-3 py-1.5 text-right">{r.gst_rate}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
